var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeliner = function SvgEyeliner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 43,
    height: 19,
    viewBox: "0 0 1.03 0.46",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.38.07c-.3.1-.41-.11-.33.07.07.17.28.24.46.29C.63.46.94.32.84.19.69 0 .58 0 .38.07z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.05,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.96.21C1 .22.88.3.84.33.56.48.43.38.21.2.43.01.65.01.96.21z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })));
};

export default SvgEyeliner;